import { Component, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { Pagination } from 'swiper';

@Component
export class LocalizationForm extends ThemeComponent {

    @Ref() button!: HTMLElement;
    @Ref() panel!: HTMLElement;
    @Ref() options!: HTMLElement[];
    @Ref() input!: HTMLInputElement;

    private form: HTMLFormElement|null = this.querySelector('form');

    init() {

        // Listen for button click - show option list
        this.$listen(this.button, 'click', () => {
            this.showOptions();
        });

        // Listen for button focus out - hide option list
        this.$listen(document.body, 'click', (e) => {
            const clickedElement = e.target as HTMLElement;
            if (!this.contains(clickedElement)) {
                this.hideOptions();
            }
        });

        // Listen for key press - hide options on ESC
        this.$listen(this, 'keyup', (e) => {
            this.onContainerKeyUp(e);
        });

        // Listen for option selection
        for (const option of this.options) {
            const optionElem = option as HTMLElement;
            this.$listen(optionElem, 'click', (e) => {
                this.onItemClick(e);
            });
        }
    }

    hideOptions() {
        this.button.setAttribute('aria-expanded', 'false');
        this.panel.setAttribute('hidden', 'true');
    }

    onContainerKeyUp(event: (this extends HTMLElement ? HTMLElementEventMap : WindowEventMap)['keyup']) {
        if (event.code.toUpperCase() !== 'ESCAPE') {
            return;
        }
        this.hideOptions();
        this.button.focus();
    }

    onItemClick(e: MouseEvent) {
        e.preventDefault();
        if (this.form && e.target) {
            const target = e.target as HTMLElement;
            const value = target.getAttribute('data-value');
            if (value) {
                this.input.value = value;
                this.form.submit();
            }
        }
    }

    showOptions() {
        this.button.focus();
        this.panel.toggleAttribute('hidden');
        this.button.setAttribute('aria-expanded', (this.button.getAttribute('aria-expanded') === 'false').toString());
    }
}
